import { Trans } from "@lingui/react/macro";
import {
  Modal,
  ModalContent,
  ModalTrigger,
  Button,
  ModalBody,
  Text,
  ModalFooter,
} from "@wootingkb/component-library";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isLoading: boolean;
}

export default function UnlinkModal({
  onConfirm,
  onClose,
  onOpenChange,
  isOpen,
  isLoading,
}: Props) {
  return (
    <Modal open={isOpen} onOpenChange={onOpenChange}>
      <ModalTrigger asChild>
        <Button variant="outline" size="sm">
          <Trans id="Discord_unlink_button">Unlink</Trans>
        </Button>
      </ModalTrigger>
      <ModalContent className="max-h-full overflow-y-auto md:max-h-[90vh]">
        <ModalBody
          title={<Trans id="Discord_unlink_modal_title">Unlink Discord</Trans>}
        >
          <Text>
            <Trans id="Discord_unlink_modal_body">
              Are you sure you want to unlink your discord?
              <br />
              You will be able to relink your account at any time.
            </Trans>
          </Text>
        </ModalBody>
        <ModalFooter className="flex justify-end">
          <Button variant="secondary" size="sm" onClick={onClose}>
            <Trans id="Common_cancel">Cancel</Trans>
          </Button>
          <Button
            variant="secondary"
            size="sm"
            onClick={onConfirm}
            isLoading={isLoading}
          >
            <Trans id="Discord_unlink_modal_confirm_button">Unlink</Trans>
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
